/**
 * Phase 23 / Plan 23-07 — Sentinel-PaymentMethod-ID für Mollie-Auto-Create.
 *
 * Wenn ein Mollie-Kurs gebucht wird und der Bucher noch keine Online-Zahlung-
 * Methode hat, sendet das Frontend diese Sentinel-ID als `paymentMethodId`.
 * Das Backend (siehe `src/server/paymentMethod/autoCreateOnlinePaymentMethod.ts`)
 * erkennt diesen Marker und löst ihn zu einer echten (auto-erstellten oder
 * existing) PaymentMethod-ID auf.
 *
 * MUSS byte-identisch mit dem Backend-Constant sein.
 */
export const AUTO_CREATE_ONLINE_PAYMENT_METHOD_MARKER = "__create_online_payment_method__";
